import { useApiGet, useApiPost, type UseApiOptions } from "@ametie/vue-muza-use";

import type { VendorBrand, VendorBrandGroup, VendorProduct } from "@/shared/types/partnership";

export interface SearchVendorProductsPayload {
  search: string
  brand: string[]
  limit: number
}

// Lives in shared (not features/partnership): the vendor filters store is a
// shared store and shared must not import from features.
export default () => {
  // cache expects a string id — a boolean resolves to id:undefined and collides
  // with every other boolean-cached GET (they share one cache bucket).
  const fetchVendorBrands = (options?: UseApiOptions<VendorBrand[]>) =>
    useApiGet("/vendor-brands", { cache: "vendor-brands", ...options });

  const fetchVendorBrandGroups = (options?: UseApiOptions<VendorBrandGroup[]>) =>
    useApiGet("/vendor-brands/groups", { cache: "vendor-brands-groups", ...options });

  const searchVendorProducts = (
    options?: UseApiOptions<VendorProduct[], SearchVendorProductsPayload>,
  ) => useApiPost("/vendor-products", options);

  return { fetchVendorBrands, fetchVendorBrandGroups, searchVendorProducts };
};
